export default {
  path: 'settings/product-categories',
  name: 'TemporaryRegulationsProductCategories',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/ProductCategoriesIndex.vue')
}
